import { render, staticRenderFns } from "./Netherlands.vue?vue&type=template&id=722ebd17&"
import script from "./Netherlands.vue?vue&type=script&lang=js&"
export * from "./Netherlands.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('722ebd17')) {
      api.createRecord('722ebd17', component.options)
    } else {
      api.reload('722ebd17', component.options)
    }
    module.hot.accept("./Netherlands.vue?vue&type=template&id=722ebd17&", function () {
      api.rerender('722ebd17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/icons/countries/Netherlands.vue"
export default component.exports